export default __webpack_public_path__ + "icon_map_pin.3ade0bc315f8ab2ba3710945dd4b33af.svg";